import React, { FC, SyntheticEvent } from "react";

import { Button, FaIcons, IconButton } from "@in/component-library";
import { AlignmentHorizontal } from "../dropdown-menu/dropdown-menu";

interface ActionToolProps {
  iconName: FaIcons;
  label: string;
  onClick: (e: SyntheticEvent) => void;
  iconButton?: boolean;
  align?: AlignmentHorizontal;
  ariaLabel: string;
}

const ActionTool: FC<ActionToolProps> = ({
  iconName,
  label,
  onClick,
  iconButton,
  align = AlignmentHorizontal.Center,
  ariaLabel
}) => {
  return iconButton ? (
    <IconButton
      iconName={iconName}
      size="medium"
      theme="neutral"
      variant="plain"
      onClick={onClick}
      className="action-tool__button--icon"
      ariaLabel={ariaLabel}
    />
  ) : (
    <Button
      iconName={iconName}
      iconPosition="left"
      size="medium"
      theme="none"
      variant="plain"
      onClick={onClick}
      className={`action-tool__button action-tool__button--${align}`}
      aria-label={ariaLabel}
    >
      {label}
    </Button>
  );
};

export default ActionTool;
